const api_url ={
    BASE_API_URL:"", // line, gpt, azure blob apiのurl
    VOICE_VOX_URL:"", // voice vox apiのurl
    DB_API_URL:"" // データベースのurl
}


module.exports = api_url
